import { PlaceholderPage } from '@/components/shell/PlaceholderPage';

export default function LegalTerms() {
  return (
    <PlaceholderPage titleKey="page.legal.terms.title" bodyKey="landing.evidence.note" />
  );
}
